import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/bootstrap_vue/index.js